// Form timing and delay constants
export const FORM_TIMING = {
  AUTO_SAVE_THROTTLE_MS: 5000,        // Minimum time between auto-saves
  STORAGE_EXPIRY_MS: 48 * 60 * 60 * 1000, // 48 hours in milliseconds
  SYNC_DELAY_MS: 100,                  // Delay for form synchronization
  RENDER_DELAY_MS: 200,                // Delay for form rendering
  HYDRATION_DELAY_MS: 300,             // Delay for form hydration
  AUTO_SAVE_DELAY_MS: 1000,            // Delay for auto-save trigger
  MANUAL_SAVE_LOCK_MS: 1500,           // Duration to lock manual save
};

// Form validation constants
export const VALIDATION = {
  EMAIL_REGEX: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  REFERENCE_COUNTRY_DEFAULT: { country: "", price: "", currency: "" },
  DEFAULT_CURRENCY: "",
};

// Storage keys pattern
export const STORAGE = {
  MULTI_FORM_PREFIX: "multiForm_",
  DRAFT_KEY: "draft",
};

export const FORM_TYPES = {
  FORM_SECTIONS: "formSections",
  DRUG_PRICING: "drugPricing",
  ECTD_UPLOAD: "ectdUpload",
  PRODUCT_DETAILS: "productDetails",
  MANUFACTURERS_SITE: "manufacturersSite",
};
